import { useState } from 'react';
import { Form, Row, Col, Button, Card, Image } from 'react-bootstrap';
import ProfileMobileSectionActions from './ProfileMobileSectionActions';
import icStar from './assets/img/ic-star-square.svg';
import icStarYellow from './assets/img/ic-star.svg';
import icLocalSize from './assets/img/ic-user-multiple.svg';
import icStarGray from './assets/img/ic-star-gray.svg';
import icUserGroup from './assets/img/ic-user-group.svg';

const UserAddCompany = ({ handleReset, formData, handleChange, isEditPage, handleCompanyPreferencesSubmit, hideEdit, isLastSection = false, requireCompanySize = true }) => {
    const [isEditing, setIsEditing] = useState(!isEditPage); // If adding, fields start enabled
    const [tempFormData, setTempFormData] = useState({ ...formData }); // Store initial values

    // Enable editing mode
    const handleEditClick = () => {
        setIsEditing(true);
        setTempFormData({ ...formData }); // Store previous values
    };

    // ✅ Save changes and disable editing
    const handleSaveClick = async (e) => {
        e.preventDefault();
        if (typeof handleCompanyPreferencesSubmit === 'function') { // ✅ Ensure it's a function before calling
            await handleCompanyPreferencesSubmit(e);
            setIsEditing(false); // ✅ Exit edit mode after saving
        } else {
            console.error('Error: handleCompanyPreferencesSubmit is not a function.');
        }
    };

    // Cancel editing and restore previous values
    const handleCancelClick = () => {
        setIsEditing(false); // Exit edit mode

        if (typeof handleReset === 'function') {
            handleReset(tempFormData); // ✅ Restore saved values + clear errors
        }
    };

    return (
        <>
        <Card className={isLastSection ? 'mb-0 mb-md-4' : 'mb-4'}>
            <Card.Body>
                    {/* Title and Edit Button */}
                    <Row>
                        <Col>
                            <div className="profile-section-heading-row">
                            {isEditPage && !hideEdit && (
                                <div className="float-end d-none d-lg-block">
                                    {!isEditing ? (
                                        <Button variant="outline-secondary" className="btn-sm" onClick={handleEditClick}>Edit</Button>
                                    ) : (
                                        <>
                                            <Button variant="outline-secondary" className="btn-sm me-2" onClick={handleCancelClick}>Cancel</Button>
                                            <Button variant="primary" className="btn-sm" onClick={handleSaveClick}>Save</Button>
                                        </>
                                    )}
                                </div>
                            )}
                            <h3 className="company-detail-section-title d-lg-none"><span className="item-number">4.</span> Company preferences</h3>
                            <h3 className="d-none d-lg-flex"><span className="item-number">4.</span> Company preferences</h3>
                            </div>
                            <hr />
                        </Col>
                    </Row>
                    <>
                        {isEditing ? (
                            <>
                                <Row>
                                    {/* Form Fields */}
                                    <Col md={12}>
                                        <Row className="mb-3 profile-edit-fields">
                                            <Col md={3}>
                                                <Form.Group controlId="companyGlobalSize">
                                                    <Form.Label>Global company size</Form.Label>
                                                    <Form.Select
                                                        name="companyGlobalSize"
                                                        value={formData.companyGlobalSize || ''}
                                                        onChange={handleChange}
                                                        required={requireCompanySize}
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    >
                                                        <option value="">Please Select</option>
                                                        <option value="1-10">1  - 10 employees</option>
                                                        <option value="11-50">11 - 50 employees</option>
                                                        <option value="51-200">51 - 200 employees</option>
                                                        <option value="201-500">201 - 500 employees</option>
                                                        <option value="501-1000">501 - 1,000 employees</option>
                                                        <option value="1001-5000">1,001 - 5,000 employees</option>
                                                        <option value="5001-10000">5,001 - 10,000 employees</option>
                                                        <option value="10001-50000">10001 - 50000 employees</option>
                                                        <option value="50001-100000">50001 - 100000</option>
                                                        <option value="over 100000">over 100000</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group controlId="companyLocalSize">
                                                    <Form.Label>Local company size</Form.Label>
                                                    <Form.Select
                                                        name="companyLocalSize"
                                                        value={formData.companyLocalSize || ''}
                                                        onChange={handleChange}
                                                        required={requireCompanySize}
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    >
                                                        <option value="">Please Select</option>
                                                        <option value="1-10">1  - 10 employees</option>
                                                        <option value="11-50">11 - 50 employees</option>
                                                        <option value="51-200">51 - 200 employees</option>
                                                        <option value="201-500">201 - 500 employees</option>
                                                        <option value="501-1000">501 - 1,000 employees</option>
                                                        <option value="1001-5000">1,001 - 5,000 employees</option>
                                                        <option value="5001-10000">5,001 - 10,000 employees</option>
                                                        <option value="10001-50000">10001 - 50000 employees</option>
                                                        <option value="50001-100000">50001 - 100000</option>
                                                        <option value="over 100000">over 100000</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group controlId="companyRating">
                                                    <Form.Label>Company rating</Form.Label>
                                                    <Form.Select
                                                        name="companyRating"
                                                        value={formData.companyRating || ''}
                                                        onChange={handleChange}
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    >
                                                        <option value="">Please Select</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group controlId="fortune">
                                                    <Form.Label>Fortune 1000</Form.Label>
                                                    <Form.Select
                                                        name="fortune"
                                                        value={formData.fortune || ''}
                                                        onChange={handleChange}
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    >
                                                        <option value="">Please Select</option>
                                                        <option value="Yes">Yes</option>
                                                        <option value="No">No</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </>
                        ) : (
                            <>
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icUserGroup} alt="Global company size" />
                                            </span>
                                            <span className="text">
                                                Global company size
                                                <br />
                                                <strong>    
                                                    {formData.companyGlobalSize || "N/A"}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icLocalSize} alt="Local company size" />
                                            </span>
                                            <span className="text">
                                                Local company size
                                                <br />
                                                <strong>    
                                                    {formData.companyLocalSize || "N/A"}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icStar} alt="Company rating" />
                                            </span>
                                            <span className="text rating">
                                                Company Rating:
                                                <br />
                                                {Array.from({ length: 5 }).map((_, index) => (
                                                    <Image
                                                        key={index} // ✅ Correctly placed on the direct child of .map()
                                                        className="rating-star"
                                                        src={index < formData.companyRating ? icStarYellow : icStarGray}
                                                        alt=""
                                                    />
                                                ))}
    
                                                <span className="rating-text">
                                                    ({formData.rating} star)
                                                </span>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icStar} alt="Fortune 1000" />
                                            </span>
                                            <span className="text">
                                                Fortune 1000
                                                <br />
                                                <strong>    
                                                    {formData.fortune|| "N/A"}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </>
                    <ProfileMobileSectionActions
                        isEditing={isEditing}
                        onEdit={handleEditClick}
                        onCancel={handleCancelClick}
                        onSave={handleSaveClick}
                        show={isEditPage && !hideEdit}
                    />
                </Card.Body>
            </Card>
        </>
    );
};

export default UserAddCompany
